import { createSelector } from "reselect";

import {
  RecentlyStudiedCourses,
  UserStat
} from "../../../../models/state/userStats";
import { getRecentlyStudiedCourseIds as recentlyStudiedCourses_getRecentlyStudiedCourseIds } from "./recentlyStudiedCourses";
import { GetRecentlyStudiedCourseIds } from "./types";

export const getTotalStudyTime = (state: UserStat): number =>
  state.totalStudyTime;

export const getSessionsCompleted = (state: UserStat): number =>
  state.sessionsCompleted;

export const getUserLastStudied = (state: UserStat) => state.lastStudied;

export const getSessionModulesStudied = (state: UserStat): number =>
  state.sessionModulesStudied;

export const getSessionModulesCorrect = (state: UserStat): number =>
  state.sessionModulesCorrect;

export const getUserRecentlyStudiedCourses = (
  state: UserStat
): RecentlyStudiedCourses => {
  return state.recentlyStudiedCourses;
};

// @ts-ignore
export const getRecentlyStudiedCourseIds: GetRecentlyStudiedCourseIds<UserStat> =
  createSelector(
    getUserRecentlyStudiedCourses,
    recentlyStudiedCourses_getRecentlyStudiedCourseIds
  );
